import { apiClient } from './axios';

export type WhatsAppCallPermission =
  | 'none'
  | 'requested'
  | 'temporary'
  | 'permanent'
  | 'rejected'
  | 'expired';

export interface CallEligibility {
  canCallPstn: boolean;
  canCallWhatsapp: boolean;
  canSendMessage: boolean;
  mustUseTemplate: boolean;
  pstnCooldownUntil: string | null;
  whatsappCooldownUntil: string | null;
  whatsappWindowExpiresAt: string | null;
  whatsappCallPermission: WhatsAppCallPermission;
  whatsappCallPermissionExpiresAt: string | null;
}

export interface InitiateCallResponse {
  callId: string;
  callSid: string;
  wsPath: string;
  wsToken: string;
}

export const operatorCallsApi = {
  getEligibility: async (contactId: string, configurationId: string) => {
    const response = await apiClient.get<CallEligibility>('/operator-calls/eligibility', {
      params: { contactId, configurationId },
    });
    return response.data;
  },

  initiate: async (
    contactId: string,
    configurationId: string,
    channel: 'pstn' | 'whatsapp',
    overridePermission?: boolean,
  ) => {
    const response = await apiClient.post<InitiateCallResponse>('/operator-calls/initiate', {
      contactId,
      configurationId,
      channel,
      ...(overridePermission ? { overridePermission: true } : {}),
    });
    return response.data;
  },

  end: async (callSid: string) => {
    const response = await apiClient.post(`/operator-calls/${callSid}/end`);
    return response.data;
  },

  requestWhatsAppPermission: async (contactId: string, configurationId: string) => {
    const response = await apiClient.post('/operator-calls/request-whatsapp-permission', {
      contactId,
      configurationId,
    });
    return response.data;
  },

  checkWhatsAppPermission: async (contactId: string, configurationId: string) => {
    const response = await apiClient.get<{ permission: string }>(
      '/operator-calls/check-whatsapp-permission',
      { params: { contactId, configurationId } },
    );
    return response.data;
  },
};
